<template>
  <div v-if="data">
    <div class="container container-fluid bg--cardio">
      <h1 class="pull-left text-muted">Registrera kardiologpatient</h1>
      <div class="clearfix"></div>
      <!-- Skapa ny -->
      <div class="card journal-card">
        <div class="card-body">
          <p class="text-dark pull-left"><strong>Ny patient</strong></p>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="ssn">Personnummer:</label>
                <input type="number" placeholder="YYYYMMDDXXXX" class="form-control"
                  id="ssn" v-model="ssn" minlength="12" >
              </div>
              <button
                class="btn btn-primary btn-sm"
                @click="getFromNavet()"
                :disabled="!validSsn">Hämta från NAVET
              </button>
              <br />
              <small class="text-muted">
                Fyll i personnummer i formatet <i>YYYYMMDDXXXX</i> <br />
                för hämtning från NAVET
              </small>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="lastname">Efternamn:</label>
                <input type="text" class="form-control" id="lastname" v-model="lastname">
              </div>
              <div class="form-group">
                <label class="pull-left" for="email">E-post:</label>
                <input
                  type="text"
                  class="form-control"
                  id="email"
                  v-model="email"
                  autocomplete="off"
                  :class="((email && email.length > 0) && !validEmail(email)) ? 'invalid' : ''">
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="firstname">Tilltalsnamn:</label>
                <input type="text" class="form-control" id="firstname" v-model="firstname">
              </div>
              <div class="form-group">
                <label class="pull-left" for="phonenumber">Telefonnummer:</label>
                <input
                  type="text"
                  class="form-control"
                  id="phonenumber"
                  v-model="phonenumber"
                  autocomplete="off"
                  @input="enforceNumbers()">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm"></div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="clinic--select">Klinik:</label>
                <select class="form-control" id="clinic--select" v-model="originalClinic">
                  <option :value="null">Välj klinik</option>
                  <option v-for="r in data.clinicMisc.receptionlist" :value="r" :key="r">{{ r }}</option>
                </select>
              </div>
            </div>
            <div class="col-sm"></div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <!-- Personuppgifter -->
      <div class="card journal-card" v-if="populationInfo">
        <div class="card-body">
          <p class="text-dark pull-left"><strong>Personuppgifter</strong></p>
          <div class="row">
            <div class="col-sm-2">
              <p class="card-title">Address</p>
              <p class="card-title">Postkod</p>
              <p class="card-title">Stad</p>
              <p class="card-title">C/O-adressering</p>
              <p class="card-title">Dödsdatum</p>
              <p class="card-title">Sekretessmarkering</p>
              <p class="card-title">Skyddad identitet</p>
            </div>
            <div class="col-sm-4">
              <p class="card-title">{{ toTitleCase(populationInfo.streetAddress) || '-' }}</p>
              <p class="card-title">{{ populationInfo.postalCode || '-' }}</p>
              <p class="card-title">{{ toTitleCase(populationInfo.city) || '-' }}</p>
              <p class="card-title">{{ populationInfo.careOf || 'Nej' }}</p>
              <p class="card-title">{{ populationInfo.deathDate || '-' }}</p>
              <p class="card-title"
                title="Hantera uppgifterna med försiktighet!"
                :class="populationInfo.hasNoteOfSecrecy === true ? 'text-danger': ''">
                  {{ boolToText(populationInfo.hasNoteOfSecrecy) }}
              </p>
              <p class="card-title"
                title="Hantera uppgifterna med försiktighet!"
                :class="populationInfo.hasProtectedIdentity === true ? 'text-danger': ''">
                  {{ boolToText(populationInfo.hasProtectedIdentity) }}
              </p>
            </div>
            <div class="col-sm-4"></div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <!-- Screeningfrågor -->
      <div class="card journal-card">
        <div class="card-body">
          <p class="text-dark pull-left"><strong>Screeningfrågor</strong></p>
          <div class="row">
            <div class="col-sm-12 pull-left">
              <div class="form-group">
                <span class="filter cursor-pointer" v-popover:tooltip.top="data.clinicInfoIcon.scrInclusion">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <label class="scr-lbl" v-html="data.clinicCardio.screeningReasonForInclusion"></label>
                <br />
                <input type="radio" v-model="inclusionReason"
                 id="inclusionreason_sephia" :value="{ answer: 'I samband med SEPHIA kontroll efter hjärtinfrakt', code: 'inclusionreason_sephia' }">
                <label for="inclusionreason_sephia">
                  I samband med SEPHIA kontroll efter hjärtinfrakt
                </label>
                <br />
                <input type="radio" v-model="inclusionReason"
                 id="inclusionreason_xray"
                 :value="{ answer: 'I samband med genomförd kranskärlsröntgen som visat på aterosklerotisk kranskärlssjukdom', code: 'inclusionreason_xray' }">
                <label for="inclusionreason_xray">
                  I samband med genomförd kranskärlsröntgen som visat på aterosklerotisk kranskärlssjukdom
                </label>
                <br />
                <input type="radio" v-model="inclusionReason"
                 id="inclusionreason_other"
                 :value="{ answer: 'Övriga (diagnos på aterosklerotisk kranskärlssjukdom sedan tidigare)', code: 'inclusionreason_other' }">
                <label for="inclusionreason_other">
                  Övriga (diagnos på aterosklerotisk kranskärlssjukdom sedan tidigare)
                </label>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm-12 pull-left">
              <div class="form-group">
                <span class="filter cursor-pointer" v-popover:tooltip.top="data.clinicInfoIcon.scrVegan">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <label v-html="veganHeader"></label>
                <br />
                <input type="radio" :value="true" v-model="veganDiet" id="vegandiet_yes">
                <label for="vegandiet_yes">Ja</label>
                <br />
                <input type="radio" :value="false" v-model="veganDiet" id="vegandiet_no">
                <label for="vegandiet_no">Nej</label>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm-12 pull-left">
              <div class="form-group">
                <span class="filter cursor-pointer" v-popover:tooltip.top="data.clinicInfoIcon.scrLchf">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <label v-html="data.screening.dietHeader"></label>
                <br />
                <input type="radio" :value="true" v-model="lchfDiet" id="lchfdiet_yes">
                <label for="lchfdiet_yes">Ja</label>
                <br />
                <input type="radio" :value="false" v-model="lchfDiet" id="lchfdiet_no">
                <label for="lchfdiet_no">Nej</label>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm-12 pull-left">
              <div class="form-group">
                <span class="filter cursor-pointer" v-popover:tooltip.top="data.clinicInfoIcon.scrEgg">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <label v-html="data.screening.eggheader"></label>
                <br />
                <input type="radio" v-model="eggs" id="more_than_14"
                  :value="{ answer: 'Mer än 14 ägg per vecka', amount: 'more_than_14' }">
                  <label for="more_than_14">Mer än 14 ägg per vecka (2 ägg/dag)</label>
                <br />
                <input type="radio" v-model="eggs" id="less_than_14"
                  :value="{ answer: 'Mindre än 14 ägg per vecka', amount: 'less_than_14' }">
                  <label for="less_than_14">Mindre än 14 ägg per vecka (2 ägg/dag)</label>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm-12 pull-left">
              <div class="form-group">
                <span class="filter cursor-pointer" v-popover:tooltip.top="data.clinicInfoIcon.scrSmoker">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <label class="scr-lbl" v-html="data.clinicCardio.screeningSmoking"></label>
                <br />
                <input type="radio" v-model="smoking"
                 id="smoking_yes" :value="{ answer: 'Ja (pågående)', code: 'smoking_yes' }">
                <label for="smoking_yes">Ja (pågående)</label>
                <br />
                <input type="radio" v-model="smoking"
                 id="smoking_no_former_smoker"
                 :value="{ answer: 'Nej (före detta rökare)', code: 'smoking_no_former_smoker' }">
                <label for="smoking_no_former_smoker">Nej (f.d. rökare)</label>
                <br />
                <input type="radio" v-model="smoking"
                 id="smoking_no_never" :value="{ answer: 'Nej (aldrig rökt)', code: 'smoking_no_never' }">
                <label for="smoking_no_never">Nej (aldrig rökt)</label>
                <!-- <div v-if="smoking && smoking.code === 'smoking_yes'">
                  <div class="clearfix"></div>
                  <label>Om ja, ange antal cigaretter per dag:</label>
                  <select class="form-control m-w-220" v-model="cigaretteAmount">
                    <option :value="0">Välj antal</option>
                    <option v-for="amount in amountList" :value="amount" :key="amount">{{ amount }}</option>
                  </select>
                </div> -->
              </div>
            </div>
            <div class="col-sm"></div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm-12 pull-left">
              <div class="form-group">
                <span class="filter cursor-pointer" v-popover:tooltip.top="data.clinicInfoIcon.scrDiabetes">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <label class="scr-lbl" v-html="data.clinicCardio.screeningDiabetesTypeOne"></label>
                <br />
                <input type="radio" :value="true" v-model="hasDiabetesTypeOne" id="diabetes_type_one_yes">
                <label for="diabetes_type_one_yes">Ja</label>
                <br />
                <input type="radio" :value="false" v-model="hasDiabetesTypeOne" id="diabetes_type_one_no">
                <label for="diabetes_type_one_no">Nej</label>
              </div>
            </div>
            <div class="col-sm-12 pull-left">
              <div class="form-group">
                <label class="scr-lbl" v-html="data.clinicCardio.screeningDiabetesTypeTwo"></label>
                <br />
                <input type="radio" :value="true" v-model="hasDiabetesTypeTwo" id="diabetes_type_two_yes">
                <label for="diabetes_type_two_yes">Ja</label>
                <br />
                <input type="radio" :value="false" v-model="hasDiabetesTypeTwo" id="diabetes_type_two_no">
                <label for="diabetes_type_two_no">Nej</label>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm-12 pull-left">
              <div class="form-group">
                <span class="filter cursor-pointer" v-popover:tooltip.top="data.clinicInfoIcon.scrHypertension">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <label class="scr-lbl" v-html="data.clinicCardio.screeningHypertension"></label>
                <br />
                <input type="radio" :value="true" v-model="hasHypertension" id="hypertension_yes">
                <label for="hypertension_yes">Ja</label>
                <br />
                <input type="radio" :value="false" v-model="hasHypertension" id="hypertension_no">
                <label for="hypertension_no">Nej</label>
              </div>
            </div>
          </div>
          <!-- Lägga till provsvar samt referensintervaller -->
          <div id="addtestresults" class="card opacity-card" v-if="intervalLists">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-5">
                  <p class="text-dark pull-left">Enligt journaluppgifter högsta uppmätta obehandlade LDL-kolesterol</p>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">LDL</span>
                    </div>
                    <input type="text" class="form-control" v-model="bloodtest_temp_add.ldlHighestMeasured">
                  </div>
                </div>
                <div class="col-sm-2">
                  <p class="text-dark pull-left"><strong>Enhet</strong></p>
                  <div class="input-group mb-3">
                    <input type="text" class="form-control" v-model="bloodtest_temp_add.ldlUnit" disabled>
                  </div>
                </div>
                <div class="col-sm-5">
                  <p class="text-dark pull-left"><strong>Referensintervall</strong></p>
                  <div class="input-group mb-3">
                      <select class="form-control" v-model="bloodtest_temp_add.ldlReferenceInterval">
                        <option :value="''">Välj intervall för LDL</option>
                        <option
                          v-for="(ldl, i) in intervalLists.clinicMisc.ldlRefList"
                          v-html="ldl"
                          :key="i"
                          :title="toElementTitle(ldl)">
                        </option>
                      </select>
                  </div>
                </div>
              </div>
              <hr />
              <p class="text-dark pull-left" id="add-testresults"><strong>Ange senaste resultatet för blodfetter</strong></p>
              <div class="row">
                <div class="col-sm">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Provdatum</span>
                    </div>
                    <date-pick v-model="bloodtest_temp_add.testDate" :displayFormat="'YYYY-MM-DD'"
                    :inputAttributes="{name: bloodtest_temp_add.testDate, id: 'bloodTestDate', class: ['form-control'],
                      readonly: true, placeholder: 'Välj provdatum'}">
                    </date-pick>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-5">
                  <p class="text-dark pull-left"><strong>Provsvarsresultat</strong></p>
                  <div class="input-group mb-3">
                    <span class="filter icon cursor-pointer"
                      v-if="bloodtest_temp_add.triglycerider && bloodtest_temp_add.triglycerider.replace(/,/g, '.') >= 4.5"
                        v-popover:tooltip.top="data.clinicInfoIcon.triglyceridesTooHigh">
                      <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                    </span>
                    <div class="input-group-prepend">
                      <span class="input-group-text">Triglycerider</span>
                    </div>
                    <input type="text" class="form-control" v-model="bloodtest_temp_add.triglycerider">
                  </div>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Totalkolesterol</span>
                    </div>
                    <input type="text" class="form-control" v-model="bloodtest_temp_add.totalKolesterol">
                  </div>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">HDL</span>
                    </div>
                    <input type="text" class="form-control" v-model="bloodtest_temp_add.hdl">
                  </div>
                  <label class="left">Beräknad LDL värde från Friedewalds (om TG&#60;4,5mmol/L)</label>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">LDL</span>
                    </div>
                    <input type="text" class="form-control"
                      v-model="bloodtest_temp_add.ldlFriedewalds"
                      :class="(bloodtest_temp_add.triglycerider && bloodtest_temp_add.triglycerider.replace(/,/g, '.') >= 4.5)
                        ? 'disable-edit': 'opacity-full'" disabled>
                  </div>
                  <label class="left">LDL värde från direktmätningsmetod (om TG&#62;4,5mmol/L)</label>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">LDL</span>
                    </div>
                    <input type="text" class="form-control" v-model="bloodtest_temp_add.ldlUncalculated"
                    :disabled="bloodtest_temp_add.ldlFriedewalds.length > 0">
                  </div>
                  <label class="left">Senaste uppmätta Lipoprotein (a) värdet</label>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Lipoprotein (a)</span>
                    </div>
                    <input type="text" class="form-control" v-model="bloodtest_temp_add.lipoProteinA">
                  </div>
                </div>
                <div class="col-sm-2">
                  <p class="text-dark pull-left"><strong>Enhet</strong></p>
                  <div class="input-group mb-3">
                    <input type="text" class="form-control" v-model="bloodtest_temp_add.triglyceriderUnit" disabled>
                  </div>
                  <div class="input-group mb-3">
                    <input type="text" class="form-control" v-model="bloodtest_temp_add.totalKolesterolUnit" disabled>
                  </div>
                  <div class="input-group mb-3">
                    <input type="text" class="form-control" v-model="bloodtest_temp_add.hdlUnit" disabled>
                  </div>
                  <div class="input-group mb-1">&nbsp;</div>
                  <div class="input-group mb-3">
                    <input type="text" class="form-control" v-model="bloodtest_temp_add.ldlUnit" disabled>
                  </div>
                  <div class="input-group mb-2">&nbsp;</div>
                  <div class="input-group mb-3">
                    <input type="text" class="form-control" v-model="bloodtest_temp_add.ldlUnit" disabled>
                  </div>
                  <div class="input-group mb-1">&nbsp;</div>
                  <div class="input-group mb-3">
                    <select class="form-control" v-model="bloodtest_temp_add.lipoProteinAUnit">
                      <option :value="''">Enhet för Lipoprotein (a)</option>
                      <option
                        v-for="(unit, i) in intervalLists.clinicMisc.lipoproteinRefList"
                        v-html="unit"
                        :key="i"
                        :title="toElementTitle(unit)">
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-5">
                  <p class="text-dark pull-left"><strong>Referensintervall</strong></p>
                  <div class="input-group mb-3">
                      <select class="form-control" v-model="bloodtest_temp_add.triglyceriderReferenceInterval">
                        <option :value="''">Välj intervall för Triglycerider</option>
                        <option
                          v-for="(t, i) in intervalLists.clinicMisc.triglyceriderRefList"
                          v-html="t"
                          :key="i"
                          :title="toElementTitle(t)">
                        </option>
                      </select>
                  </div>
                  <div class="input-group mb-3">
                      <select class="form-control" v-model="bloodtest_temp_add.totalKolesterolReferenceInterval">
                        <option :value="''">Välj intervall för Totalkolesterol</option>
                        <option
                          v-for="(tk, i) in intervalLists.clinicMisc.totalkolesterolRefList"
                          v-html="tk"
                          :key="i"
                          :title="toElementTitle(tk)">
                        </option>
                      </select>
                  </div>
                  <div class="input-group mb-3">
                      <select class="form-control" v-model="bloodtest_temp_add.hdlReferenceInterval">
                        <option :value="''">Välj intervall för HDL</option>
                        <option
                          v-for="(hdl, i) in intervalLists.clinicMisc.hdlRefList"
                          v-html="hdl"
                          :key="i"
                          :title="toElementTitle(hdl)">
                        </option>
                      </select>
                  </div>
                  <div class="input-group mb-1">&nbsp;</div>
                  <div class="input-group mb-3">
                      <select class="form-control" v-model="bloodtest_temp_add.ldlReferenceInterval">
                        <option :value="''">Välj intervall för LDL</option>
                        <option
                          v-for="(ldl, i) in intervalLists.clinicMisc.ldlRefList"
                          v-html="ldl"
                          :key="i"
                          :title="toElementTitle(ldl)">
                        </option>
                      </select>
                  </div>
                  <div class="input-group mb-2">&nbsp;</div>
                  <div class="input-group mb-3">
                      <select class="form-control" v-model="bloodtest_temp_add.ldlReferenceInterval">
                        <option :value="''">Välj intervall för LDL</option>
                        <option
                          v-for="(ldl, i) in intervalLists.clinicMisc.ldlRefList"
                          v-html="ldl"
                          :key="i"
                          :title="toElementTitle(ldl)">
                        </option>
                      </select>
                  </div>
                </div>
                <div class="col-sm"></div>
              </div>
            </div>
          </div>
          <div class="alert alert-success alert-bloodtest">
            <strong>Provsvar är tillagt samt sparat.</strong>
          </div>
          <div class="clearfix"></div>
          <div class="row">
            <div class="col-sm-8 pull-left pull-left">
              <div class="card opacity-card">
                <div class="card-body">
                  <div class="form-group">
                    <label v-html="data.clinicCardio.medicineHeaderCardio"></label>
                    <!--
                      <tags-input element-id="tags" v-model="drugs" placeholder=" Lägg till läkemedel"
                      :existing-tags="fhDrugTags" :typeahead-hide-discard="true" :typeahead-always-show="true"
                      :typeahead="true"></tags-input>
                    -->
                    <div v-for="(fhDrug, grouping) in fhDrugsArray" :key="grouping">
                      <p class="text-dark pull-left">
                        <strong>{{ fhDrug.grouping }}</strong>
                      </p>
                      <select class="form-control" v-model="fhDrug.value.selectedDrug" @change="fhDrug.value.selectedDosage = ''"
                      :disabled="noDrugs">
                        <option :value="''">Välj läkemedel</option>
                        <option
                          v-for="(drug, i) in fhDrug.value.drugsInGroup"
                          v-html="drug.drug"
                          :value="drug"
                          :key="i"
                          :title="toElementTitle(drug.drug)">
                        </option>
                      </select>
                      <select class="form-control" v-model="fhDrug.value.selectedDosage"
                      :disabled="fhDrug.value.selectedDrug == ''">
                        <option :value="''">Välj enhet</option>
                        <option
                           v-for="(dosages, i) in fhDrug.value.selectedDrug.dosages"
                          v-html="dosages.doseAmount + ' ' + dosages.doseUnit"
                          :value="dosages"
                          :key="i"
                          :title="toElementTitle(dosages.doseAmount + ' ' + dosages.doseUnit)">
                        </option>
                      </select>
                      <p class="text-dark pull-left" v-if="fhDrug.value.selectedDrug.frequency === 'day'">
                        <strong>Enhet avser en tablett per dag</strong>
                      </p>
                      <p class="text-dark pull-left" v-if="fhDrug.value.selectedDrug.frequency === 'byWeekly'">
                        <strong>Enhet avser en injection enligt fast dosinterval</strong>
                      </p>
                      <div class="clearfix"></div>
                    </div>
                    <label for="nodrugs">Patienten tar inga läkemedel:</label> &nbsp;
                    <input type="checkbox" @change="resetFhDrugs()" v-model="noDrugs" id="nodrugs">
                  </div>
                  <div class="row">
                    <div class="col-sm-5">
                      <!-- <p class="text-dark pull-left"><strong>Provsvarsresultat</strong></p> -->
                      <label class="left">Beräknad obehandlat LDL värde</label>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text">LDL</span>
                        </div>
                        <input type="text" class="form-control"
                          v-model="ldlUntreated" :class="(ldlUntreated && ldlUntreated.length > 0)
                            ? 'opacity-full' : 'disable-edit'" disabled>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <!-- <p class="text-dark pull-left"><strong>Enhet</strong></p> -->
                      <label class="left">&nbsp;</label>
                      <div class="input-group mb-3">
                        <input type="text" class="form-control" v-model="ldlUntreatedUnit" disabled>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm"></div>
          </div>
          <hr />
          <div class="col-sm-5 pull-left">
            <label v-html="data.clinicCardio.screeningBmi"></label>
            <div class="input-group input-group-sm mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">Midjemått (cm)</span>
              </div>
              <input type="number" placeholder="Ange värde för midjemått" class="form-control" v-model="BMI.bellyCircumference">
            </div>
            <div class="input-group input-group-sm mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">Längd (cm)</span>
              </div>
              <input type="number" placeholder="Ange värde för längd" class="form-control" v-model="BMI.height">
            </div>
            <div class="input-group input-group-sm mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">Vikt (kg)</span>
              </div>
              <input type="number" placeholder="Ange värde för vikt" class="form-control" v-model="BMI.weight">
            </div>
            <div class="input-group input-group-sm mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">BMI</span>
              </div>
              <input type="text" class="form-control form-control-bmi" v-model="summaryBMI" disabled>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <!-- DLCN -->
      <div class="card dlcn-card journal-card">
        <div class="card-body">
          <div class="row">
              <div class="col-sm-4">
                <p class="text-dark pull-left" v-html="data.clinicCardio.dlcnHeader"></p>
              </div>
              <div class="col-sm"></div>
          </div>
          <div class="row">
            <div class="col-sm-10">
              <div class="input-group mb-3">
                <span class="filter icon cursor-pointer"
                   v-popover:tooltip.top="data.clinicInfoIcon.dlcnGroup1">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <div class="input-group-prepend">
                  <span class="input-group-text"><strong>Grupp 1: Familjeanamnes</strong></span>
                </div>
                <select class="form-control pull-right" v-model.number="dlcn.group1">
                  <option :value="null">Välj från grupp 1</option>
                  <option
                    v-for="(points, dlcnText) in data.clinicCardio.dlcnGroupOne"
                    v-html="dlcnText"
                    :key="dlcnText"
                    :value="{ name: dlcnText, points: parseInt(points) }"
                    :title="toElementTitle(dlcnText)">
                  </option>
                </select>
              </div>
              <div class="input-group mb-3">
                <span class="filter icon cursor-pointer"
                   v-popover:tooltip.top="data.clinicInfoIcon.dlcnGroup2">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <div class="input-group-prepend">
                  <span class="input-group-text"><strong>Grupp 2: Patientens anamnes</strong></span>
                </div>
                <select class="form-control pull-right" v-model.number="dlcn.group2">
                  <option :value="null">Välj från grupp 2</option>
                  <option
                    v-for="(points, dlcnText) in data.clinicCardio.dlcnGroupTwo"
                    v-html="dlcnText"
                    :key="dlcnText"
                    :value="{ name: dlcnText, points: parseInt(points) }"
                    :title="toElementTitle(dlcnText)">
                  </option>
                </select>
              </div>
              <div class="input-group mb-3">
                <span class="filter icon cursor-pointer"
                   v-popover:tooltip.top="data.clinicInfoIcon.dlcnGroup3">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <div class="input-group-prepend">
                  <span class="input-group-text"><strong>Grupp 3: Patientens fysikaliska status</strong></span>
                </div>
                <select class="form-control pull-right" v-model.number="dlcn.group3">
                  <option :value="null">Välj från grupp 3</option>
                  <option
                    v-for="(points, dlcnText) in data.clinicCardio.dlcnGroupThree"
                    v-html="dlcnText"
                    :key="dlcnText"
                    :value="{ name: dlcnText, points: parseInt(points) }"
                    :title="toElementTitle(dlcnText)">
                  </option>
                </select>
              </div>
              <div class="input-group mb-3">
                <span class="filter icon cursor-pointer"
                   v-popover:tooltip.top="data.clinicInfoIcon.dlcnGroup4">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <div class="input-group-prepend">
                  <span class="input-group-text"><strong>Grupp 4: Patientens LDL-kolesterol (obehandlat)</strong></span>
                </div>
                <select class="form-control pull-right" v-model.number="dlcn.group4">
                  <option :value="null">Välj från grupp 4</option>
                  <option
                    v-for="(points, dlcnText) in data.clinicCardio.dlcnGroupFour"
                    v-html="dlcnText"
                    :key="dlcnText"
                    :value="{ name: dlcnText, points: parseInt(points) }"
                    :title="toElementTitle(dlcnText)">
                  </option>
                </select>
              </div>
              <div class="input-group mb-3">
                <span class="filter icon cursor-pointer"
                   v-popover:tooltip.top="data.clinicInfoIcon.dlcnGroup5">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <div class="input-group-prepend">
                  <span class="input-group-text"><strong>Grupp 5: Genetiskt test</strong></span>
                </div>
                <select class="form-control pull-right" v-model.number="dlcn.group5">
                  <option :value="null">Välj från grupp 5</option>
                  <option
                    v-for="(points, dlcnText) in data.clinicCardio.dlcnGroupFive"
                    v-html="dlcnText"
                    :key="dlcnText"
                    :value="{ name: dlcnText, points: parseInt(points) }"
                    :title="toElementTitle(dlcnText)">
                  </option>
                </select>
              </div>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text input-group-text-summary font-weight-bold" v-html="data.clinicCardio.dlcnSummary"></span>
                </div>
                <input type="text" class="font-weight-bold form-control pull-right" id="dlcnSummary" v-model="dlcnSummary" disabled>
              </div>
              <p class="pull-right" v-html="data.clinicCardio.dlcnText"></p>
            </div>
            <div class="col-sm-2">
              <div v-if="dlcn.group2">
                <div v-if="dlcn.group2.points === 1">
                  <br><br>
                  <p class="left">
                    Läs mer om prematur cerebral samt perifer kärlsjukdom
                    <a href="https://janusinfo.se/behandling/expertgruppsutlatanden/hjartochkarlsjukdomar/hjartochkarlsjukdomar/identifieraperiferartarsjukdomgenomattfragaeftersymtomochmataankelbrakialindextillstandetmedformyckethogkardiovaskularrisk.5.2e489e9216f1a8cad2a71776.html"
                      target="_blank">här</a>
                  </p>
                </div>
                <div v-if="dlcn.group2.points === 2">
                  <br><br>
                  <p class="left">
                    Läs mer om prematur CHD
                    <a href="https://www.ahajournals.org/doi/full/10.1161/CIRCULATIONAHA.107.688739"
                      target="_blank">här</a>
                    och <a href="https://media.springernature.com/m685/springer-static/image/art%3A10.1097%2F00125817-200307000-00003/MediaObjects/41436_2003_Article_BFgim200345_Fig1_HTML.jpg"
                      target="_blank">förtydligande bild</a>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-sm">
              <div class="pull-left border-1" v-if="isDev">
                <label>Dev:</label>
                <input type="number" class="form-control" v-model.number="personId" placeholder="personId" />
                <div class="clearfix"></div>
                <button class="btn btn-primary btn-sm" @click="addCardioPatientScreeningAnswers()">
                  cardio/screeninganswers
                </button>
              </div>
            </div>
            <div class="col-sm"></div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <!-- Alert success -->
      <div class="alert alert-success alert-bottom-right alert-createnewcardio-success">
        <strong>Registreringen av kardiologpatient är utfört.</strong>
      </div>
      <!-- Alert warning -->
      <div class="alert alert-danger alert-bottom-right alert-createnewcardio-validation-error">
        <strong>Något obligatoriskt fält saknas, var vänlig fyll i det innan du registrerar uppgifter för patienten.</strong>
      </div>
      <!-- Alert fail -->
      <div class="alert alert-danger alert-bottom-right alert-createnewcardio-error">
        <strong>{{error}}</strong>
      </div>
      <!-- End of process -->
      <div class="btn-group">
        <button class="btn btn-lg btn-primary" @click="addCardioPatientPersonalData()" :disabled="!isFieldsValid">
          Registrera uppgifter
        </button>
        <button class="btn btn-lg btn-danger" @click="confirmLeave()">Avbryt</button>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { request } from '../plugins/datocms'
import { inRange } from '../plugins/numberhelper'
import { friedewalds } from '../plugins/friedewalds'
import { luhnSsn } from '../plugins/luhnssn'
import FieldId from '../plugins/fieldid'
import { fhDrugs } from '../plugins/fhdrugs'
import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css'
import $ from 'jquery'

export default {
  name: 'createnewcardio',
  components: {
    DatePick
  },
  props: ['id'],
  data () {
    return {
      data: null,
      smoking: null,
      inclusionReason: null,
      intervalLists: null,
      hasDiabetesTypeOne: null,
      hasDiabetesTypeTwo: null,
      hasHypertension: null,
      BMI: {
        bellyCircumference: null,
        height: null,
        weight: null
      },
      dlcn: {
        group1: null,
        group2: null,
        group3: null,
        group4: null,
        group5: null
      },
      bloodtest_temp_add: {
        testDate: null,
        ldl: '',
        ldlFriedewalds: '',
        ldlUncalculated: '',
        ldlHighestMeasured: '',
        hdl: '',
        totalKolesterol: '',
        triglycerider: '',
        lipoProteinA: '',
        ldlUnit: 'mmol/L',
        hdlUnit: 'mmol/L',
        totalKolesterolUnit: 'mmol/L',
        triglyceriderUnit: 'mmol/L',
        lipoProteinAUnit: '',
        ldlReferenceInterval: '',
        hdlReferenceInterval: '',
        totalKolesterolReferenceInterval: '',
        triglyceriderReferenceInterval: ''
      },
      ldlUntreated: '',
      ldlUntreatedUnit: 'mmol/L',
      ldl: null,
      drugs: null,
      noDrugs: null,
      ssn: null,
      fhDrugTags: [],
      fhDrugsArray: fhDrugs,
      populationInfo: null,
      eggs: null,
      veganDiet: null,
      lchfDiet: null,
      phonenumber: null,
      email: null,
      personId: null,
      originalClinic: null,
      lastname: '',
      firstname: '',
      error: 'Det gick inte att registrera kardiologpatient, vänligen försök igen om en stund.',
      cigaretteAmount: 0,
      isDev: process.env.NODE_ENV === 'dev'
    }
  },
  methods: {
    toElementTitle (str) {
      if (str) {
        let res = $('<textarea />').html(str).text() // convert special html entity chars
        res = res.replace(/<[^>]*>?/gm, '') // strip html tags
        return res
      }
    },
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    boolToText (bool) {
      if (bool) {
        return 'Ja ⚠️'
      } else {
        return 'Nej'
      }
    },
    enforceNumbers () {
      this.phonenumber = this.phonenumber.replace(/ /g, '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
    },
    validEmail (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    emptyMailPhone () {
      this.phonenumber = null
      this.email = null
    },
    getFieldId (lbl) {
      return FieldId(lbl)
    },
    getFromNavet () {
      let loader = this.$loading.show()
      axios.postPopulationRegistry(config.populationRegistryUri, this.ssn).then((response) => {
        if (response) {
          this.populationInfo = response.data
          this.firstname = response.data.firstName !== null ? response.data.firstName : ''
          this.lastname = response.data.lastName !== null ? response.data.lastName : ''
          loader.hide()
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          console.log(error)
        }
      })
    },
    prePopulateReferenceIntervals (age, gender) {
      if (inRange(age, 0, 1)) {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[0]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[0]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[0]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[0]
      } else if (inRange(age, 1, 14)) {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[1]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[0]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[1]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[1]
      } else if (inRange(age, 14, 17) && gender === 'Kvinna') {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[1]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[1]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[1]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[2]
      } else if (inRange(age, 14, 17) && gender === 'Man') {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[1]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[2]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[1]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[3]
      } else if (inRange(age, 18, 30) && gender === 'Kvinna') {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[2]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[3]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[4]
      } else if (inRange(age, 18, 30) && gender === 'Man') {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[2]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[4]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[4]
      } else if (inRange(age, 31, 50) && gender === 'Kvinna') {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[3]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[3]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[5]
      } else if (inRange(age, 31, 50) && gender === 'Man') {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[3]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[4]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[5]
      } else if (inRange(age, 51, 120) && gender === 'Kvinna') {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[4]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[3]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[6]
      } else if (inRange(age, 51, 120) && gender === 'Man') {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[4]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[4]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[6]
      }
    },
    confirmLeave () {
      const r = confirm('Är du säker? Du kan ha osparade ändringar.')
      if (r) {
        this.$router.go(-1)
      }
    },
    async addCardioPatientPersonalData () {
      const r = confirm('Är du säker på att du vill registrera kardiologpatient?')
      if (r) {
        if (this.isFieldsValid) {
          const personalData = {
            ssn: this.ssn.toString(),
            firstname: this.firstname,
            lastname: this.lastname,
            email: this.email,
            phonenumber: this.phonenumber,
            originalclinic: this.originalClinic
          }
          let loader = this.$loading.show()
          if (personalData) {
            axios.postCardioPatientPersonalData(config.cardioUri + config.personalDataUri, personalData).then((response) => {
              if (response) {
                this.personId = response.data.personId
                if (this.personId) {
                  this.addCardioPatientScreeningAnswers()
                } else {
                  loader.hide()
                  $('.alert-createnewcardio-error').show().delay(4000).fadeOut()
                }
              }
            }, (error) => {
              if (error.response && error.response.status === 401) {
                window.location.href = window.location.origin.concat('/error')
              } else {
                loader.hide()
                this.error = error.response.data ? error.response.data[0] : this.error
                $('.alert-createnewcardio-error').show().delay(4000).fadeOut()
                console.log(error)
              }
            })
          }
        } else {
          $('.alert-createnewcardio-validation-error').show().delay(4000).fadeOut()
        }
      }
    },
    async addCardioPatientScreeningAnswers () {
      let screeningAnswers = [
        {
          personId: this.personId,
          answer: JSON.stringify({
            question: 'Patienten inkluderas i digifysisk FH screening',
            reason: this.inclusionReason,
            timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
          }),
          fieldId: 6135399 // screeningreasonforinclusion
        },
        {
          personId: this.personId,
          answer: JSON.stringify({
            question: 'Har patienten hypertoni?',
            answer: (this.hasHypertension ? 'Ja' : 'Nej'),
            timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
          }),
          fieldId: 6132773 // screeninghypertension
        },
        {
          personId: this.personId,
          answer: JSON.stringify({
            question: 'Patientens midjemått, längd, vikt och BMI',
            values: this.BMI,
            summary: this.summaryBMI,
            timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
          }),
          fieldId: 6132814 // screeningbmi
        },
        {
          personId: this.personId,
          answer: JSON.stringify({
            question: 'Är patienten rökare?',
            smoking: this.smoking,
            // amount: this.cigaretteAmount !== 0 ? this.cigaretteAmount : null,
            timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
          }),
          fieldId: 5649280 // screeningsmoking
        },
        {
          personId: this.personId,
          answer: JSON.stringify({
            question: 'Har patienten diabetes typ 1?',
            answer: (this.hasDiabetesTypeOne ? 'Ja' : 'Nej'),
            timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
          }),
          fieldId: 5649270 // screeningdiabetestype1
        },
        {
          personId: this.personId,
          answer: JSON.stringify({
            question: 'Har patienten diabetes typ 2?',
            answer: (this.hasDiabetesTypeTwo ? 'Ja' : 'Nej'),
            timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
          }),
          fieldId: 5649269 // screeningdiabetestype2
        },
        {
          personId: this.personId,
          answer: JSON.stringify({
            question: 'Dutch Lipid Score',
            dlcn: this.dlcn,
            summary: this.dlcnSummary,
            timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
          }),
          fieldId: 5679764 // screeningdlcn
        },
        {
          personId: this.personId,
          answer: JSON.stringify({
            question: 'Äter du rent vegansk kost?',
            answer: (this.veganDiet ? 'Ja' : 'Nej'),
            timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
          }),
          fieldId: 8963171 // screeningvegan
        },
        {
          personId: this.personId,
          answer: JSON.stringify({
            question: 'Äter patienten en fettrik kost med få kolhydrater (t.ex. LCHF)?',
            answer: (this.lchfDiet ? 'Ja' : 'Nej'),
            timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
          }),
          fieldId: 1293109 // screeningdiet
        },
        {
          personId: this.personId,
          answer: JSON.stringify({
            question: 'Hur många ägg äter patienten en genomsnittlig vecka?',
            eggs: this.eggs,
            timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
          }),
          fieldId: 1293536 // screeningegg
        },
        {
          personId: this.personId,
          answer: JSON.stringify({
            question: 'Har patienten en pågående behandling med kolesterolsänkande läkemedel?',
            answer: (this.noDrugs ? 'Nej' : 'Ja'),
            drugs: (this.noDrugs ? '' : this.convertPropInArray(this.fhDrugsArray)),
            timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
          }),
          fieldId: 5818344 // screeningmedicine_cardio
        }
      ]
      if (screeningAnswers && screeningAnswers.length > 0) {
        axios.postCardioPatientScreeningAnswers(config.screeninganswerUri, screeningAnswers).then((response) => {
          if (response) {
            this.addBloodtest()
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            $('.alert-createnewcardio-error').show().delay(4000).fadeOut()
            console.log(error)
          }
        })
      }
    },
    async addBloodtest () {
      let loader = this.$loading.show()
      this.bloodtest_temp_add.personId = this.personId
      this.bloodtest_temp_add.ldl = JSON.stringify({
        ldlHighestMeasured: this.bloodtest_temp_add.ldlHighestMeasured,
        ldlFriedewalds: this.bloodtest_temp_add.ldlFriedewalds,
        ldlUntreated: this.ldlUntreated,
        ldlUncalculated: this.bloodtest_temp_add.ldlUncalculated
      })
      axios.postBloodTest(config.bloodtestUri, this.bloodtest_temp_add).then(response => {
        if (response) {
          $('.alert-createnewcardio-success').show().delay(4000).fadeOut()
          setTimeout(() => {
            loader.hide()
            window.location.href = window.location.origin.concat('/patientscardio')
          }, 2000)
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not send bloodtest: ' + error)
          loader.hide()
        }
      })
    },
    convertPropInArray (fhDrugsArray) {
      let drugs = []
      fhDrugsArray.forEach(fhd => {
        if (fhd.value['selectedDosage']) {
          // calculatedLDL *= fhd.value['selectedDosage'].correctionFactor
          let drug = {
            name: fhd.value['selectedDrug'].drug,
            grouping: fhd.value['selectedDrug'].grouping,
            dose: fhd.value['selectedDosage'].doseAmount,
            unit: fhd.value['selectedDosage'].doseUnit
          }
          if (fhd.value['selectedDrug'].frequency === 'day') {
            drug.amountperday = '1'
          } else {
            drug.injectionsperweek = '1'
          }
          drugs.push(drug)
        }
      })
      if (drugs) {
        return drugs
      }
    },
    calcualteGroup4ByLDL (ldlValue) {
      let parsedLdl = ldlValue.replace(/,/g, '.')
      let targetValue = '0'
      if (parsedLdl < 4) {
        targetValue = '0'
      } else if (parsedLdl < 5) {
        targetValue = '1'
      } else if (parsedLdl < 6.5) {
        targetValue = '3'
      } else if (parsedLdl < 8.5) {
        targetValue = '5'
      } else {
        targetValue = '8'
      }
      for (const [key, value] of Object.entries(this.data.clinicCardio.dlcnGroupFour)) {
        if (value === targetValue) {
          this.dlcn.group4 = { name: key, points: parseInt(value) }
          return
        }
      }
    },
    calculateUntreatedLDL () {
      // Select ldl to calculate
      let ldlToCalculate = ''
      if (this.bloodtest_temp_add.ldlFriedewalds !== '') {
        ldlToCalculate = this.bloodtest_temp_add.ldlFriedewalds
      } else if (this.bloodtest_temp_add.ldlUncalculated !== '') {
        ldlToCalculate = this.bloodtest_temp_add.ldlUncalculated
      }

      // Calculate ldl
      if (ldlToCalculate) {
        let calculatedLDL = ldlToCalculate.replace(/,/g, '.')
        this.fhDrugsArray.forEach(fhd => {
          if (fhd.value['selectedDosage']) {
            calculatedLDL *= fhd.value['selectedDosage'].correctionFactor
          }
        })
        if (calculatedLDL) {
          calculatedLDL = parseFloat(calculatedLDL).toFixed(2)
          this.ldlUntreated = calculatedLDL
        }
      } else {
        this.ldlUntreated = ''
      }

      // Select DLCN group 4 based on ldl
      if (this.bloodtest_temp_add.ldlHighestMeasured) {
        this.calcualteGroup4ByLDL(this.bloodtest_temp_add.ldlHighestMeasured)
      } else if (this.bloodtest_temp_add.ldlFriedewalds !== '' || this.bloodtest_temp_add.ldlUncalculated !== '') {
        this.calcualteGroup4ByLDL(this.ldlUntreated)
      } else {
        this.ldlUntreated = ''
        this.dlcn.group4 = null
      }
    },
    resetFhDrugs () {
      this.fhDrugsArray.forEach(fhd => {
        fhd.value['selectedDrug'] = ''
        fhd.value['selectedDosage'] = ''
      })
    },
    validateFhDrugs () {
      let hasSelectedDrug = false
      let hasError = false
      this.fhDrugsArray.forEach(fhd => {
        if (fhd.value['selectedDrug'] !== '' && fhd.value['selectedDosage'] !== '') {
          hasSelectedDrug = true
        } else if ((fhd.value['selectedDrug'] && fhd.value['selectedDosage'] === '') ||
          (fhd.value['selectedDrug'] === '' && fhd.value['selectedDosage'])) {
          hasError = true
        }
      })
      return hasSelectedDrug && !hasError
    }
  },
  watch: {
    bloodtest_temp_add: {
      handler (bt) {
        if (bt.hdl.length > 0 && bt.totalKolesterol.length > 0 && (bt.triglycerider.length > 0 && bt.triglycerider.replace(/,/g, '.') < 4.5)) {
          this.ldl = friedewalds(
            bt.totalKolesterol.replace(/,/g, '.'), bt.hdl.replace(/,/g, '.'), bt.triglycerider.replace(/,/g, '.')
          )
          this.bloodtest_temp_add.ldlUncalculated = ''
          this.bloodtest_temp_add.ldlFriedewalds = this.ldl
        } else {
          this.ldl = null
          this.bloodtest_temp_add.ldlFriedewalds = ''
        }
        this.calculateUntreatedLDL()
      },
      deep: true
    },
    fhDrugsArray: {
      handler (fhd) {
        this.calculateUntreatedLDL()
      },
      deep: true
    },
    drugs: {
      handler (d) {
        if (d && d.length > 0) {
          this.noDrugs = null
        }
      },
      deep: true
    },
    noDrugs (nd) {
      if (nd === false) {
        this.noDrugs = null
      }
    },
    getAge (age) {
      if (age) {
        this.prePopulateReferenceIntervals(age, this.getGender)
      }
    }
  },
  computed: {
    veganHeader () {
      if (this.data.screening) {
        return this.data.screening.veganHeader
          .replace(/(&nbsp;|<([^>]+)>)/ig, '')
          .replace(/.*/, '')
          .substr(1)
      }
    },
    getAge () {
      if (this.validSsn) {
        const today = new Date()
        const birthDate = new Date(this.ssn.substring(0, 4) +
          '/' + this.ssn.substring(4, 6) + '/' + this.ssn.substring(6, 8))
        let age = today.getFullYear() - birthDate.getFullYear()
        const m = today.getMonth() - birthDate.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--
        }
        return age
      }
    },
    getGender () {
      if (this.validSsn) {
        const n = parseInt(this.ssn.charAt(10))
        if (n % 2 === 0) { // Even Number
          return 'Kvinna'
        }
        return 'Man'
      }
    },
    amountList () {
      return Array.from({length: 200}, (_, i) => i + 1)
    },
    dlcnSummary () {
      const points1 = this.dlcn.group1 ? this.dlcn.group1.points : 0
      const points2 = this.dlcn.group2 ? this.dlcn.group2.points : 0
      const points3 = this.dlcn.group3 ? this.dlcn.group3.points : 0
      const points4 = this.dlcn.group4 ? this.dlcn.group4.points : 0
      const points5 = this.dlcn.group5 ? this.dlcn.group5.points : 0
      const sum = points1 + points2 + points3 + points4 + points5
      return sum
    },
    summaryBMI () {
      if (this.BMI.weight && this.BMI.height) {
        const bmi = this.BMI.weight / (this.BMI.height / 100 * this.BMI.height / 100)
        return bmi.toFixed(2)
      }
      return ''
    },
    isFieldsValid () {
      /* Help end-user with validation before registering patient - mandatory fields include:
         personnummer, efternamn, tilltalsnamn, epost eller tfnr, samtliga screeningfrågor,
         blodfetter förutom lipoprotein (a) och dess enhet, läkemedel (mått, dos, antal) eller checkbox (inga läkemedel)
      */
      if (this.validSsn && (this.firstname && this.firstname.length !== 0) && (this.lastname && this.lastname.length !== 0) &&
        (this.inclusionReason !== null && this.lchfDiet !== null && this.eggs !== null && this.hasHypertension !== null &&
        this.smoking !== null && this.hasDiabetesTypeOne !== null && this.hasDiabetesTypeTwo !== null) &&
        (this.validateFhDrugs() || this.noDrugs !== null) &&
        ((this.bloodtest_temp_add.testDate !== null || this.bloodtest_temp_add.testDate.length !== 0) &&
        ((this.bloodtest_temp_add.ldlHighestMeasured && this.bloodtest_temp_add.ldlHighestMeasured.length !== 0) ||
        (this.bloodtest_temp_add.ldlFriedewalds && this.bloodtest_temp_add.ldlFriedewalds.length !== 0) ||
        (this.bloodtest_temp_add.ldlUncalculated && this.bloodtest_temp_add.ldlUncalculated.length !== 0)) &&
        this.bloodtest_temp_add.hdl.length !== 0 && this.originalClinic !== null &&
        this.bloodtest_temp_add.totalKolesterol.length !== 0 &&
        this.bloodtest_temp_add.triglycerider.length !== 0 &&
        this.bloodtest_temp_add.ldlReferenceInterval.length !== 0 &&
        this.bloodtest_temp_add.hdlReferenceInterval.length !== 0 &&
        this.bloodtest_temp_add.totalKolesterolReferenceInterval.length !== 0 &&
        this.bloodtest_temp_add.triglyceriderReferenceInterval.length !== 0) &&
        (((this.email && this.email.length !== 0) || (this.phonenumber && this.phonenumber.length >= 8)))) {
        return true
      }
      return false
    },
    validSsn () {
      const ssnValid = luhnSsn(this.ssn)
      return ssnValid
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          clinicMisc {
            mutationlist
            receptionlist
          }
          screening {
            veganHeader
            dietHeader
            eggheader
            verifycontactheader
            verifydiagnosisheader
            verifygentestheader
            verifymutationheader
          }
          clinicCardio {
            screeningReasonForInclusion
            screeningDiabetesTypeOne
            screeningDiabetesTypeTwo
            screeningSmoking
            screeningHypertension
            screeningBmi
            medicineHeaderCardio
            dlcnHeader
            dlcnSummary
            dlcnText
            dlcnGroupOne
            dlcnGroupTwo
            dlcnGroupThree
            dlcnGroupFour
            dlcnGroupFive
          }
          clinicInfoIcon {
            triglyceridesTooHigh
            scrVegan
            scrSmoker
            scrLchf
            scrInclusion
            scrHypertension
            scrEgg
            scrDiabetes
            dlcnGroup1
            dlcnGroup2
            dlcnGroup3
            dlcnGroup4
            dlcnGroup5
          }
        }
      `
    })
    this.intervalLists = await request({
      query: `
        {
          clinicMisc {
            ldlRefList
            hdlRefList
            triglyceriderRefList
            totalkolesterolRefList
            lipoproteinRefList
          }
        }
      `
    })
    if (this.data.screening) {
      this.data.screening = JSON.parse(
        JSON.stringify(this.data.screening)
          .replaceAll('du', 'patienten')
          .replaceAll('din', 'patienten')
      )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding-right: 10px;
}
button:disabled {
  opacity: 0.3;
}
select:disabled {
  opacity: 0.5;
}
input[type=text]:disabled {
  opacity: 0.5;
}
.disable-edit {
  opacity: 0.3;
  pointer-events: none;
}
input[type=checkbox] {
  transform: scale(1.5);
}
.form-control-bmi {
  opacity: 1.0 !important;
  font-weight: bold;
}
.opacity-full {
  opacity: 1.0 !important;
  background-color: #f2f3f5;
}
.m-w-220 {
  max-width: 220px;
}
.m-w-270 {
  max-width: 270px;
}
.border-1 {
  border: 1px solid gray;
  max-width: 260px;
  padding: 10px;
}
.scr-lbl {
  margin-bottom: -0.33em !important;
}
.icon {
  line-height: 33px;
  margin-right: 8px;
}
.left {
  float: left;
}
.pull-left {
  text-align: left;
}
.pull-right {
  text-align: right;
}
.invalid {
  border: 2px solid red;
}
.journal-card:hover {
  background: #bed4b4;
  border: 1px solid #abc2a0;
  color: #000;
  opacity: 1.0;
}
.journal-card {
  background: #CDE5C3;
  border: 1px solid #b7ccae;
  color: #38362E;
  opacity: 0.8;
}
.opacity-card {
  background-color: rgba(0, 0, 0, 0.05);
  border: 1px solid #b7ccae;
}
.dlcn-card input:disabled {
  opacity: 1.0 !important;
  background-color: #f2f3f5;
}
.dlcn-card .input-group-text {
  background: rgb(236, 231, 231) !important;
  min-width: 24vw;
}
.input-group-text-summary {
  min-width: 25.75vw !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CreateNewCardio.vue